import { CarouselManager } from "../utils/carouselManager";
import {fetchRetailRecommendations} from "./g-utils"
class CartRecommendations extends HTMLElement {
  static observedAttributes = ["data-product-count"];

  constructor() {
    super();

    this._splideList = this.querySelector(".splide__list");
    this._init = false;
    this.productCount = 0;
    this.additionalCount = 5;
  }

  connectedCallback() {
    this._initSlider();
    if (window.location.pathname === "/cart") {
      this._fetchRecommendations();
    } else {
      const miniCart = this.closest("g-modal");

      if (miniCart && miniCart.expanded) {
        this._fetchRecommendations();
      } else if (miniCart) {
        const observer = new MutationObserver((mutationsList) => {
          for (const mutation of mutationsList) {
            if (
              mutation.type === "attributes" &&
              mutation.attributeName === "aria-expanded" &&
              mutation.target.getAttribute(mutation.attributeName) === "true"
            ) {
              this._fetchRecommendations();
              observer.disconnect();
            }
          }
        });

        observer.observe(miniCart, {
          attributes: true, // Observe attribute changes
        });
      }
    }
    document.documentElement.addEventListener(
      "product:added",
        this._checkPresenceInCart.bind(this)
    );
  }

  async attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case "data-product-count":
        if (Number(newValue) <= this.maxProductCount && Number(oldValue) > this.maxProductCount) {
          await this._fetchRecommendations();
        }
        if (this.productCount === 0 && this._init) {
          this.style.display = "none";
        } else {
          this.style.display = "";
        }
        break;
    }
  }

  async _fetchRecommendations() {
    const isbns = await this._fetchIsbns();

    if (isbns.data.length == 0) return;

    const isbnsForOptions = isbns.data.map((isbn) => {
      return { primaryProductId: isbn };
    });  
    try {
      const recommendationsJson = await fetchRetailRecommendations({
        type: "cart",
        products: isbnsForOptions,
        pageSize: this.maxProductCount + this.additionalCount,
      })

      const presentIsbns = Array.from(
        this.querySelectorAll("product-item, cart-drawer-recommendations-item")
      ).map((item) => item.isbn);
      const productHandles = recommendationsJson.result.products
        .map((item) => item.isbn)
        .filter((recommendationIsbn) => {
          return (
            isbns.data.findIndex((isbn) => isbn === recommendationIsbn) === -1 &&
            presentIsbns.indexOf(recommendationIsbn) === -1
          );
        })
        .join(",");

      let url = "";

      if(this.location === "cart-page") {
        url = `/?section_id=ajax-cart-recommendations&product_handles=${productHandles}`;
      } else {
        url = `/?section_id=ajax-cart-drawer-recommendations&product_handles=${productHandles}`;
      }

      if(this.dataset.carouselId) {
        url += `&carousel_id=${this.dataset.carouselId}`;
      }
      if(this.dataset.carouselName) {
        url += `&carousel_name=${encodeURI(this.dataset.carouselName)}`
      }

      const sectionResponse = await fetch(url);
      const sectionHtml = await sectionResponse.text();

      const sectionElement = document.createElement("div");
      sectionElement.innerHTML = sectionHtml;
      const newSplideList = sectionElement.querySelector(".js-carousel-items");
      if (!this._init) {
        this._init = true;
        this._splideList.innerHTML = "";
      }
      this._splideList.insertAdjacentHTML("beforeend", newSplideList.innerHTML);
      this.productCount = this.querySelectorAll(".splide__slide").length;
      if(this.splide && window.innerWidth >= 640) {
        this.splide.refresh();
      }
    } catch (error) {
      console.error(error);
    }
  }

  async _initSlider() {
    const splideEl = this.querySelector(".splide");

    let options = {};
    if (this.location === "cart-page") {
      options = {
        gap: 16,
        arrows: false,
        pagination: false,
        autoHeight: true,
        fixedWidth: 200,
        drag: "free",
        lazyload: "nearby",
        preloadPages: 1,
        breakpoints: {
          640: {
            destroy: true,
          },
        },
      };
    } else if (this.location === "cart-drawer") {
      options = {
        padding: 20,
        arrows: false,
        pagination: false,
        fixedWidth: "75%",
        autoHeight: true,
        drag: "free",
        lazyload: "nearby",
        preloadPages: 1,
        breakpoints: {
          640: {
            destroy: true,
          },
        },
      };
    }

    this.splide = await CarouselManager.create(splideEl, options);
    this._initSliderArrows();
  }

  _initSliderArrows() {
    const sliderNavEl = this.querySelector(".slider-nav");
    if (sliderNavEl) {
      const navNextBtn = sliderNavEl.querySelector(".nav-next");
      const navPrevBtn = sliderNavEl.querySelector(".nav-prev");

      const maxIndex = () => {
        const maxIndex = this.splide.Components.Controller.getEnd() - this.visibleSlides + 1;
        const currentIndex = this.splide.Components.Controller.getIndex();
        
        if(maxIndex === currentIndex) {
          return true;
        } else if(maxIndex < currentIndex) {
          this.splide.Components.Controller.setIndex(maxIndex);
          return true;
        } else {
          return false;
        }
      }

      navNextBtn.addEventListener("click", () => {
        if(maxIndex()) return;
        this.splide.go(">");
      });

      navPrevBtn.addEventListener("click", () => {
        maxIndex();
        this.splide.go("<");
      });
    } else {
      console.warn("No slider nav found");
    }
  }

  get visibleSlides() {
    if (!this.splide) return 1;
    if(!this._visibleSlides || this._windowWidth !== window.innerWidth) {
      this._windowWidth = window.innerWidth;
      this._visibleSlides = this.splide.root.querySelectorAll(".splide__slide.is-visible").length
    }
    return this._visibleSlides;
  }

  async _checkPresenceInCart(e) {
    const variantId = parseInt(e.detail.variant);
    if (variantId) {
      const items = this.querySelectorAll("product-item, cart-drawer-recommendations-item");
      for (let item of items) {
        if (item.variants.variants.indexOf(variantId) !== -1) {
          item.closest(".splide__slide").remove();
          this.productCount = this.productCount - 1;
          this.splide.refresh();
          break;
        }
      }
    }
  }

  async _fetchIsbns() {
    const response = await fetch(window.Shopify.routes.root + "?sections=ajax-cart-items-isbns");
    const json = await response.json();
    const tmpDiv = document.createElement("div");
    tmpDiv.innerHTML = json[Object.keys(json)[0]];
    const result = JSON.parse(tmpDiv.querySelector(".isbn-json").innerHTML);

    return result;
  }

  get location() {
    return this.dataset.location;
  }

  set productCount(value) {
    this.dataset.productCount = Number(value);
  }

  get productCount() {
    return Number(this.dataset.productCount);
  }

  get maxProductCount() {
    return Number(this.dataset.maxProductCount);
  }
}

customElements.define("cart-recommendations", CartRecommendations);
